import { render, staticRenderFns } from "./GridCanvas.vue?vue&type=template&id=47a7ebaf&"
import script from "./GridCanvas.vue?vue&type=script&lang=js&"
export * from "./GridCanvas.vue?vue&type=script&lang=js&"
import style0 from "./GridCanvas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports